import { Component, inject, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ChipEnvironementComponent } from '../chip-environement/chip-environement.component';
import { ModeConfiguration } from '../header/header-configuration';
import { ModeService } from '../../services/mode.service';

/**
 * Pied de page de Pegase.
 *
 * Le rendu gestionnaire (puce d'environnement, version, mention
 * d'homologation) ou apprenant (liens + copyright) n'est pas un input : il
 * vient de {@link ModeService}, comme pour le header, afin que les deux ne
 * puissent pas se désynchroniser.
 */
@Component({
  selector: 'lib-pegase-footer',
  templateUrl: './footer.component.html',
  imports: [MatIcon, ChipEnvironementComponent],
  standalone: true,
})
export class FooterComponent {
  @Input() version = '';

  private modeService = inject(ModeService);

  protected readonly currentYear = new Date().getFullYear();

  protected get config(): ModeConfiguration {
    return this.modeService.configuration;
  }
}